import type { Permissions } from '@/rbac/grants'
import { isPermissionGrantActive } from '@/rbac/isPermissionGrantActive'

export type ViewGrantScope = 'none' | 'all' | 'partial'

export function getViewGrantScope(grant: unknown): ViewGrantScope {
	if (!isPermissionGrantActive(grant)) {
		return 'none'
	}
	if (grant === true || grant === 'all') {
		return 'all'
	}
	if (typeof grant === 'object' && grant !== null && 'all' in grant) {
		return 'all'
	}
	return 'partial'
}

export function viewGrantAllowsModule(grant: unknown): boolean {
	return isPermissionGrantActive(grant)
}

export function hasViewGrantForPermission(
	permissions: Permissions | undefined,
	permission: keyof Permissions,
): boolean {
	return isPermissionGrantActive(permissions?.[permission])
}

export function hasAnyViewGrant(permissions: Permissions | undefined, permissionKeys: (keyof Permissions)[]): boolean {
	return permissionKeys.some(key => hasViewGrantForPermission(permissions, key))
}
